<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-text class="font-weight-light pb-0 custom-background">
        Batch
      </v-card-text>
      <v-card-text class="pt-0 custom-background">
        Editing Batch Detail
      </v-card-text>

      <v-container>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="batchName"
              v-validate="'required'"
              data-vv-name="batch name"
              label="Name"
            />
          </v-col>
        </v-row> 
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      batch: {
        type: Object,
        required: true,
      },    
    },
    data () {
      return {
        progressing: false,
        menu: null,
        localBatch: null,
        batchName: null,
      }
    },

    watch: {
      menu: function (value) {
        if (!value) return
        this.localBatch = { ...this.batch }
        this.batchName = this.localBatch.name
      },
    },

    methods: {
      submitForm () {
        this.progressing = true

        this.$api.companySalaryBatch().update(this.batch.id, this.prepareFormData())
          .then(response => {
            this.$snack({ message: 'Batch updated' })
            this.$emit('updated')

            this.progressing = false
            this.menu = false
          })
          .catch(() => {
            this.progressing = false
          })
      },

      prepareFormData () {
        return {
          name: this.batchName,
        }
      },

    },
  }
</script>

<style  scoped>
.custom-background{
  background-color:#5cb860 ;
  color:white !important
}
</style>
